import React, {useEffect, useState} from 'react';
import {theme} from '../../../styles/darkTheme';
import Badge from '../../atoms/Badge';
import {useNavigate} from 'react-router-dom';
import {
  BadgeContainer,
  Container,
  LightText,
  NameText,
  RowContainer,
  ButtonsContainer,
  ModalButton,
} from './styles';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../redux/reducers';
import {User} from '../../../models/User';
import {Channel} from 'stream-chat';
import {
  archiveChannel,
  getCurrentChannel,
  hideChannel,
} from '../../../redux/actions/channel';
import moment from 'moment';
import {useTranslation} from '../../../context/language';
import {selectChat as selectChatByID} from '../../../redux/actions/channel';
import {useLongPress} from 'use-long-press';
import Alert from '../../atoms/Alert';

interface Props {
  channel: Channel;
}

const ChatChard: React.FC<Props> = ({channel}) => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const {text} = useTranslation();

  const user = useSelector((state: RootState) => ({...state.user}));
  const [info, setInfo] = useState<User>({} as User);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [isDeleteVisible, setIsDeleteVisible] = useState<boolean>(false);
  const [unreadMessages, setUnreadMessages] = useState<number>(
    channel.countUnread(),
  );

  const bind = useLongPress(() => {
    setIsVisible(true);
  });

  const hideChat = () => {
    dispatch(hideChannel(channel));
  };

  const archiveChat = () => {
    dispatch(archiveChannel(channel));
  };

  useEffect(() => {
    if (!channel.data?.name) {
      setInfo(
        (Object.values(channel.state.members).find(
          item => item.user_id !== user.id,
        )?.user as User) || ({} as User),
      );
    }

    const handlingEvent = (event: any) => {
      setUnreadMessages(channel.countUnread());
    };

    const handlingNew = (event: any) => {
      const currentChannel = dispatch(getCurrentChannel());
      if (
        event.type === 'message.new' &&
        currentChannel?.id != event.channel_id
      ) {
        //Send notification
        setUnreadMessages(channel.countUnread());
      }
    };

    channel.on('message.new', handlingNew);
    channel.on('message.read', handlingEvent);

    return () => {
      channel.off('message.new', handlingNew);
      channel.off('message.read', handlingEvent);
    };
  }, []);

  const getLastMessage = (): string => {
    return (
      channel.lastMessage()?.text ||
      (channel.lastMessage()?.attachments &&
        channel.lastMessage()?.attachments?.length &&
        channel.lastMessage().attachments[0].type) ||
      ''
    );
  };

  const lastMessage = getLastMessage();

  const getDate = (): string => {
    const today = new Date();
    const date = new Date(
      channel.lastMessage()?.created_at || '',
    );
    const isToday: boolean =
      date.getDate() == today.getDate() &&
      date.getMonth() == today.getMonth() &&
      date.getFullYear() == today.getFullYear();
    if (isToday) {
      return (
        text.today +
        ' ' +
        moment(
          new Date(
            channel.lastMessage()?.created_at || '',
          ),
        ).format('h:mm a')
      );
    } else {
      return moment(
        new Date(
          channel.lastMessage()?.created_at || '',
        ),
      ).format('MM/DD/YYYY');
    }
  };

  const getUnreadMessages = () => {
    return unreadMessages <= 9 ? unreadMessages : '+9';
  };

  const selectChat = ({id}: {id: string}): void => {
    if (id) {
      dispatch(
        selectChatByID({
          id,
          callback: () => {
            history('/chat_room');
          },
        }),
      );
    }
  };

  const handleSelect = () => {
    if (isVisible || isDeleteVisible) return;
    selectChat({id: channel.id });
  };

  return (
    <Container theme={theme} onClick={handleSelect} {...bind}>
      <RowContainer>
        <NameText theme={theme}>{channel.data?.name || info.name}</NameText>
        <LightText theme={theme}>{getDate()}</LightText>
      </RowContainer>
      <RowContainer>
        {lastMessage && (
          <LightText theme={theme} width="70" align="left">
            {getLastMessage()}
          </LightText>
        )}
        {+unreadMessages ? (
          <BadgeContainer>
            <Badge size={18}>{getUnreadMessages()}</Badge>
          </BadgeContainer>
        ) : null}
      </RowContainer>
      <Alert
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        title={text.warning}
        message={text.deleteMessage}>
        <ButtonsContainer>
          <ModalButton theme={theme} onClick={archiveChat}>
            {text.archive}
          </ModalButton>
          <ModalButton
            theme={theme}
            onClick={() => {
              setIsVisible(false);
              setIsDeleteVisible(true);
            }}>
            {text.delete}
          </ModalButton>
        </ButtonsContainer>
      </Alert>
      <Alert
        isVisible={isDeleteVisible}
        setIsVisible={setIsDeleteVisible}
        title={text.warning}
        message={text.deleteMessage}>
        <ButtonsContainer>
          <ModalButton
            theme={theme}
            type="cancel"
            textColor={theme.secondary}
            onClick={() => setIsDeleteVisible(false)}>
            {text.cancel}
          </ModalButton>
          <ModalButton theme={theme} onClick={hideChat}>
            {text.accept}
          </ModalButton>
        </ButtonsContainer>
      </Alert>
    </Container>
  );
};

export default ChatChard;
